/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  class SubcollectionsSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiperRef = null;
    }

    connectedCallback() {
      const swiperEl = this.querySelector('.swiper');

      this.swiperRef = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        navigation: {
          nextEl: '.subcollections__tabs-wrapper .swiper-button-next',
          prevEl: '.subcollections__tabs-wrapper .swiper-button-prev',
        },
        pagination: {
          el: '.subcollections__tabs-wrapper .swiper-pagination',
          clickable: true,
        },
      });
    }
  }

  if (!customElements.get('subcollections-swiper')) {
    customElements.define('subcollections-swiper', SubcollectionsSwiper);
  }
})();
